import { __assign } from "tslib";
import * as React from 'react';
import { getLegacyBaseDriverFromWrapper } from '../../common/base-driver';
import { createTabsDriverLegacyDriver } from '../../primitives/tabs/tabs.legacy-driver';
import { renderAndMountComponent } from '@wix/answers-lib';
import { TabsContainer } from './tabs-container';
export var createTabsContainerDriverLegacyDriver = function (wrapper) {
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, '.tabs-container', 'tabs-container');
    var tabsDriver = createTabsDriverLegacyDriver(baseDriver.elem);
    return {
        getTabTexts: function () {
            return tabsDriver.getTabTexts();
        },
        getSelected: function () {
            return tabsDriver.getSelected();
        },
        selectTabAtIndex: function (idx) {
            return tabsDriver.selectTab(idx);
        }
    };
};
export var createTabsContainer = function (props) {
    var elem = renderAndMountComponent(React.createElement(TabsContainer, __assign({}, props)));
    return createTabsContainerDriverLegacyDriver(elem);
};
//# sourceMappingURL=tabs-container.legacy-driver.js.map